"use client";
import { useEffect } from 'react';
import '../utils/assertion.js';
import { getParentIFrame } from '../utils/iframeUtils/getParentIFrame.js';
import { isIframeWithIframeResizer } from '../utils/iframeUtils/isIframe.js';
import { usePrevious } from './usePrevious.js';

/**
 * Скроллит iframe до положения диалогового окна в зависимости от видимости и fullscreen параметров.
 *
 * @param {IFrameScrollToDialog} params - Параметры для управления скроллом.
 * @param {RefObject<HTMLDivElement>} params.dialogRef - Ссылка на HTML-элемент диалога.
 * @param {boolean} params.fullscreen - Определяет, должен ли iframe быть на весь экран.
 * @param {boolean} params.visible - Параметр видимости модального окна.
 * @returns {void}
 */
const useIframeScrollToDialog = ({ dialogRef, fullscreen, visible, }) => {
    const prevVisible = usePrevious(visible);
    const dialogHeight = dialogRef?.current?.offsetHeight ?? 0;
    useEffect(() => {
        if (isIframeWithIframeResizer() && visible && prevVisible !== visible) {
            const offsetY = fullscreen ? 0 : Math.round((window.innerHeight - dialogHeight) / 2);
            getParentIFrame()?.scrollToOffset(0, offsetY);
        }
    }, [fullscreen, visible, prevVisible, dialogHeight, dialogRef]);
};

export { useIframeScrollToDialog };
//# sourceMappingURL=useIframeScrollToDialog.js.map
